//@ts-check
import React from 'react';
import DropdownButtonEntry from './Entry';
import placeholders from '../../data/placeholders';
import DataList from '../../data/List';
/** @param {import('./types').DropdownButtonDataListProps<any>} props */

var DropdownButtonDataList = function DropdownButtonDataList(_ref) {
  var dataType = _ref.dataType,
      dataProps = _ref.dataProps,
      createDataOptionValue = _ref.createDataOptionValue;
  return React.createElement(DataList, {
    dataType: dataType,
    dataProps: dataProps,
    id: dataType + '-dropdown'
  }, function (_ref2) {
    var state = _ref2.state;
    return state.data.map(function (data) {
      return React.createElement(DropdownButtonEntry, {
        key: placeholders('{id}', {
          dataType: dataType
        }, data),
        option: {
          label: placeholders('{label}', {
            dataType: dataType
          }, data),
          value: createDataOptionValue ? createDataOptionValue(data) : data
        }
      });
    });
  });
};

export default DropdownButtonDataList;